import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/toast.css';

interface ToastProviderProps {
  children: React.ReactNode;
}

/**
 * Provider de Toasts que encapsula a ToastContainer
 * Deve ser adicionado ao componente raiz da aplicação
 */
const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  return (
    <>
      {children}
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        limit={5} // Máximo de 5 toasts simultâneos
      />
    </>
  );
};

export default ToastProvider;
